import { ReactNode, useMemo } from 'react';
import styled from 'styled-components';

import { CmsApiBlock } from 'modules/cms/api/types/CmsApiBlock';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsBlockContainerWithDividers } from 'modules/cms/components/BlocksWithContainer';
import { getNextRealBlock } from 'modules/cms/helpers/getNextRealBlock';
import { getPrevRealBlock } from 'modules/cms/helpers/getPrevRealBlock';
import { CmsMappedBlock } from 'modules/cms/mappers/CmsMappedBlock';
import { gutterWidth } from 'theme';

const Content = styled.div`
  flex: 1 1 auto;
  width: 100%;
`;

type Props = {
  content: CmsApiPage;
  mappedBlocks: CmsMappedBlock<CmsApiBlock>[];
  socialButtons: ReactNode | null | undefined;
  subscribeButton: ReactNode | null | undefined;
};

export function CmsBodyMainContent({
  content,
  mappedBlocks,
  socialButtons,
  subscribeButton,
}: Props) {
  const { layout } = content;

  const hasBelowBlocks = useMemo(
    () =>
      content.hasRecommendedJobs ||
      (content.tags && content.tags.length > 0) ||
      content.author,
    [content.author, content.hasRecommendedJobs, content.tags],
  );

  const hasFooter = Boolean(hasBelowBlocks || socialButtons || subscribeButton);

  return (
    <Content data-qa-id="cms-main-content" data-qa-content-layout={layout}>
      {mappedBlocks.map((mappedBlock, index) => {
        if (mappedBlock.type === 'ANCHOR') return null;

        return (
          <CmsBlockContainerWithDividers
            key={mappedBlock.id}
            mappedBlock={mappedBlock}
            prevBlock={getPrevRealBlock(mappedBlocks, index)}
            nextBlock={getNextRealBlock(mappedBlocks, index)}
            layout={content.layout}
            index={index}
            isLastBlock={index === mappedBlocks.length - 1}
          >
            {mappedBlock.component}
          </CmsBlockContainerWithDividers>
        );
      })}

      {hasFooter && <div style={{ marginTop: gutterWidth }} />}
    </Content>
  );
}
